import topFilter from "./topFilter.service";

const topFilterAutoWheelService = {
  async fetchPossibleValues(params) {
    return topFilter.fetchPossibleValues('/catalog/api/auto/wheel/filter-preparation', params);
  },
  async searchProducts(params) {
    return topFilter.searchProducts('/catalog/api/auto/wheel/search', params);
  },
};

export default topFilterAutoWheelService;
